import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClassPassenger = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m2.368 5.292 2.303 11.053h8.75v1.843H3.152L.526 5.292h1.842Zm3.123.028c.304-.05.617-.033.912.055.249.074.488.185.7.35l1.51 1.17c1.152.902 2.82 1.436 4.32 1.151v1.962c-1.722.295-3.288-.303-4.744-1.123l.95 3.776h4.495l5.314 4.145-1.382 1.382-3.518-2.764h-8.51l-1.76-7.7A2.09 2.09 0 0 1 5.473 5.32h.018Zm-2.33-3.85a1.852 1.852 0 0 1 2.57-.451 1.854 1.854 0 0 1 .45 2.569 1.854 1.854 0 0 1-2.569.452 1.855 1.855 0 0 1-.45-2.57Z" })
});
export default SvgClassPassenger;
